"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatosGenerales = exports.DatosGeneralesData = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var reactstrap_1 = require("reactstrap");
var dataPrueba = [
    { label: 'Ecuatoriano', value: '1' },
    { label: 'Blanco', value: 'Dolphin' },
    { label: 'Soltero', value: 'Whale' },
    { label: 'Masculino', value: 'Octopus' },
    { label: 'Hombre', value: '5' },
];
var DatosGeneralesData = /** @class */ (function () {
    function DatosGeneralesData() {
        this.id = 0;
        this.apellidos = "Rivadenira Ruiz";
        this.nombres = "Pedro Nicolás";
        this.identificacion = "090703365";
        this.fecha_caducidad = "08/03/2020";
        this.evidencia = "";
        this.email_personal = "privadenira@gmail.com";
        this.email_espol = "privadenira@espol.edu.ec";
        this.pais = "";
        this.provincia = "";
        this.canton = "";
        this.fecha_nacimiento = "24/08/1990";
        this.nacionalidad = "Ecuatoriana";
        this.identificacion_etnica = "Blanco";
        this.estado_civil = "Soltero";
        this.sexo = "Masculino";
        this.identificacion_genero = "Hombre";
    }
    return DatosGeneralesData;
}());
exports.DatosGeneralesData = DatosGeneralesData;
var DatosGenerales = /** @class */ (function (_super) {
    __extends(DatosGenerales, _super);
    function DatosGenerales(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: "", loading: false, dtoData: new DatosGeneralesData(), paisList: [], provinciaList: [], ciudadList: [], nacionalidadList: [], identificacionEtnicaList: [], estadoCivilList: [], sexoList: [], identificacionGeneroList: [] };
        //Ejemplo de obtenr data por medio de API
        //fetch('http://localhost:43788/api/ContactosQS/Opciones/Titulo')
        //    .then(response => response.json() as Promise<Array<any>>)
        //    .then(data => {
        //        this.setState({ paisList: data });
        //    });
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit employee  
        if (dtoid > 0) {
            fetch('http://localhost:43788/api/ContactosQS/Contact/' + dtoid)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                _this.setState({ title: "Edit", loading: false, dtoData: data });
            });
        }
        // This will set state for Add employee  
        else {
            _this.state = { title: "Create", loading: false, dtoData: new DatosGeneralesData(), paisList: [], provinciaList: [], ciudadList: [], nacionalidadList: [], identificacionEtnicaList: [], estadoCivilList: [], sexoList: [], identificacionGeneroList: [] };
        }
        // This binding is necessary to make "this" work in the callback  
        _this.handleSave = _this.handleSave.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        return _this;
    }
    DatosGenerales.prototype.handleInputChange = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var dto = this.state.dtoData;
        dto[name] = value;
        this.setState({ dtoData: dto });
    };
    DatosGenerales.prototype.handleSave = function (event) {
        var _this = this;
        //type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];        
        event.preventDefault();
        var forma = new FormData(event.target);
        var dto = this.state.dtoData;
        forma.forEach(function (value, clave) {
            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });
        var data = JSON.stringify(dto);
        // PUT request for Edit employee.  
        if (this.state.dtoData.id > 0) {
            fetch('http://localhost:43788/api/ContactosQS/Contact/' + this.state.dtoData.id, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                _this.props.history.push("/fetch-contactos");
            });
        }
        // POST request for Add employee.  
        else {
            fetch('http://localhost:43788/api/ContactosQS/Contact/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                _this.props.history.push("/fetch-contactos");
            });
        }
    };
    // This will handle Cancel button click event.  
    DatosGenerales.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.props.history.push("/fetch-contactos");
    };
    DatosGenerales.prototype.render = function () {
        var contents = this.state.loading
            ? React.createElement("p", null,
                React.createElement("em", null, "Loading..."))
            : this.renderForm(this.state.paisList, this.state.provinciaList, this.state.ciudadList, this.state.nacionalidadList, this.state.identificacionEtnicaList, this.state.estadoCivilList, this.state.sexoList, this.state.identificacionGeneroList);
        return React.createElement("div", { className: "content col-9" }, contents);
    };
    DatosGenerales.prototype.handleEdit = function (id) {
        this.props.history.push("/ver-contacto/" + id);
    };
    DatosGenerales.prototype.renderForm = function (paisList, provinciaList, ciudadList, nacionalidadList, identificacionEtnicaList, estadoCivilList, sexoList, identificacionGeneroList) {
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardHeader, null,
                            React.createElement("h5", { className: "title" }, "DATOS GENERALES")),
                        React.createElement(reactstrap_1.CardBody, null,
                            React.createElement("div", null,
                                React.createElement("form", { onSubmit: this.handleSave },
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("input", { type: "hidden", name: "id", value: this.state.dtoData.id })),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "nombres_apellidos" }, "Nombres / Apellidos*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement("input", { className: "form-control-plaintext", type: "text", defaultValue: this.state.dtoData.nombres + " " + this.state.dtoData.apellidos, required: true }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "identificacion" }, "Identificaci\u00F3n*"),
                                        React.createElement("div", { className: "col-md-3" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement("input", { className: "form-control", type: "text", name: "identificacion", defaultValue: this.state.dtoData.identificacion, required: true }),
                                                React.createElement("div", { className: "input-group-append", style: { backgroundColor: "#FFC200" } },
                                                    React.createElement("i", { className: "fas fa-address-card", "aria-hidden": "true" })))),
                                        React.createElement("div", { className: "col-md-3" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement("input", { className: "form-control", type: "date", name: "fecha_caducidad", defaultValue: this.state.dtoData.fecha_caducidad, required: true }))),
                                        React.createElement("div", { className: "col-md-3" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement("input", { className: "form-control", type: "text", name: "evidencia", defaultValue: this.state.dtoData.evidencia, required: true }),
                                                React.createElement("div", { className: "input-group-append", style: { backgroundColor: "#FFC200" } },
                                                    React.createElement("i", { className: "fas fa-upload", "aria-hidden": "true" }))))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "email_personal" }, "Email personal*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement("input", { className: "form-control", type: "text", name: "email_personal", defaultValue: this.state.dtoData.email_personal, required: true }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "email_espol" }, "Email ESPOL*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement("input", { className: "form-control-plaintext", type: "text", name: "email_espol", defaultValue: this.state.dtoData.email_espol, required: true }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "identificacion" },
                                            "Lugar de nacimiento: ",
                                            React.createElement("strong", null, "Pais/Provincia/Cant\u00F3n*")),
                                        React.createElement("div", { className: "col-md-3" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement("input", { className: "form-control", type: "text", name: "pais", defaultValue: this.state.dtoData.pais, required: true }),
                                                React.createElement("div", { className: "input-group-append", style: { backgroundColor: "#FFC200" } },
                                                    React.createElement("i", { className: "fas fa-map-marker-alt", "aria-hidden": "true" })))),
                                        React.createElement("div", { className: "col-md-3" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement("input", { className: "form-control", type: "text", name: "provincia", defaultValue: this.state.dtoData.provincia, required: true }),
                                                React.createElement("div", { className: "input-group-append", style: { backgroundColor: "#FFC200" } },
                                                    React.createElement("i", { className: "fas fa-map-marker-alt", "aria-hidden": "true" })))),
                                        React.createElement("div", { className: "col-md-3" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement("input", { className: "form-control", type: "text", name: "canton", defaultValue: this.state.dtoData.canton, required: true }),
                                                React.createElement("div", { className: "input-group-append", style: { backgroundColor: "#FFC200" } },
                                                    React.createElement("i", { className: "fas fa-map-marker-alt", "aria-hidden": "true" }))))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "fecha_nacimiento" }, "Fecha nacimiento*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement("input", { className: "form-control", type: "date", name: "fecha_nacimiento", defaultValue: this.state.dtoData.fecha_nacimiento, required: true }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "nacionalidad" }, "Nacionalidad*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement(react_select_1.default, { options: dataPrueba }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "identificacion_etnica" }, "Auto identificaci\u00F3n \u00E9tnica*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement(react_select_1.default, { options: dataPrueba }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "estado_civil" }, "Estado civil*"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement(react_select_1.default, { options: dataPrueba }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "sexo" }, "Sexo"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement(react_select_1.default, { options: dataPrueba }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-3", htmlFor: "identificacion_genero" }, "Auto identificaci\u00F3n de g\u00E9nero"),
                                        React.createElement("div", { className: "col-md-9" },
                                            React.createElement(react_select_1.default, { options: dataPrueba }))),
                                    React.createElement("div", { className: "form-group row" },
                                        React.createElement("label", { className: " control-label col-md-12", htmlFor: "Info" }, "(*) Campos obligatorios")),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("button", { type: "submit", className: "btn btn-default" }, "Save"),
                                        React.createElement("button", { className: "btn", onClick: this.handleCancel }, "Cancel"))))))))));
    };
    return DatosGenerales;
}(React.Component));
exports.DatosGenerales = DatosGenerales;
exports.default = DatosGenerales;
//# sourceMappingURL=Prueba.js.map